/* eslint-disable no-param-reassign */
/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import speedometerLiquidity from './Speedometer_Liquidity_NoLoop_06_Lottie.json';


const SpeedometerLiquidity = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(speedometerLiquidity))} {...props} />
    );
}

export default SpeedometerLiquidity;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/speedometers/speedometerLiquidity.jsx